import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-qr',
  templateUrl: './modal-qr.component.html',
  styleUrls: ['./modal-qr.component.scss'],
})
export class ModalQrComponent implements OnInit {
  qrInfo = 'NA';
  nombreUsuario = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.qrInfo = data.qr;
    this.nombreUsuario = data.nombre;

    console.log('el qr mostrado es: ', this.qrInfo);
  }

  ngOnInit(): void {}

  abrirWp() {
    // La app usa rutas con '#' (useHash), por eso el link del QR es .../#/codigoQr/<id>
    const urlCodigoQr = 'https://livas.netlify.app/#/codigoQr/' + this.qrInfo;
    const mensaje =
      'Descargue de este link su codigo QR para ingresar a las piscinas ' + urlCodigoQr;
    // encodeURIComponent es clave: codifica el '#' de la ruta y los '&',
    // si no, WhatsApp recibe el texto recortado o vacío
    const urlWhatsApp = 'https://api.whatsapp.com/send?text=' + encodeURIComponent(mensaje);
    window.open(urlWhatsApp, '_blank');
  }

  descargar() {
    const canvas = document.getElementsByTagName('canvas')[0];
    if (!canvas) {
      return;
    }

    // Exportar a Blob (no a dataURL) para que la descarga funcione en iOS
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          return;
        }

        const nombreArchivo = 'codigoQR' + this.nombreUsuario + '.png';
        const archivo = new File([blob], nombreArchivo, { type: 'image/png' });
        const w = window.navigator as any;

        // En iOS Safari el atributo 'download' no descarga; usamos el Share Sheet nativo
        // (opción "Guardar imagen"), que es lo único fiable en iPhone/iPad.
        if (w.share && w.canShare && w.canShare({ files: [archivo] })) {
          w.share({ files: [archivo], title: 'Codigo QR' }).catch(() => {
            // El usuario canceló el share: intentamos la descarga normal como respaldo
            this.descargarBlob(blob, nombreArchivo);
          });
          return;
        }

        this.descargarBlob(blob, nombreArchivo);
      },
      'image/png'
    );
  }

  private descargarBlob(blob: Blob, nombreArchivo: string) {
    const url = URL.createObjectURL(blob);
    const enlaceTemporal = document.createElement('a');
    enlaceTemporal.href = url;
    enlaceTemporal.download = nombreArchivo;

    document.body.appendChild(enlaceTemporal);
    enlaceTemporal.click();
    document.body.removeChild(enlaceTemporal);

    // Se libera el objeto URL después de iniciar la descarga
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
}
